import VueI18n from 'services/i18n'
import {
  startOfToday,
  endOfYesterday,
  subDays,
  getTime,
  parse
} from 'date-fns';
import { get } from 'lodash';

export function mstohm (ms) {
  const m = Math.floor(ms / 1000 / 60)
  const h = Math.floor(m / 60)

  if (h === 0) {
    return `${m % 60}${VueI18n.t('ui.values.minutes')}`
  }

  if (m % 60 === 0) {
    return `${h}${VueI18n.t('ui.values.hours')}`
  }

  return `${h}${VueI18n.t('ui.values.hours')} ${m % 60}${VueI18n.t('ui.values.minutes')}`
}

export function getTimeRange (days) {
  return {
    from: getTime(subDays(startOfToday(), days)),
    to: getTime(endOfYesterday())
  }
}

export function addTsToPredictions(events) {
  return events.map(item => (
    Object.assign({}, item, {
      start_ts: getTime(parse(item.start)),
      end_ts: item.end === null ? null : getTime(parse(item.end))
    })
  ))
}
